import React, { useCallback, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Toolbar, Typography, IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';
import { MediaBrowser } from './MediaBrowser';
const useStyles = makeStyles(() => ({
    icon: {
        color: 'rgba(255, 255, 255, 0.54)',
    },
    dialog: {
        height: '100%',
        color: 'white',
    },
    dialogPaper: {
        height: '100%',
        maxHeight: 'calc(100% - 64px)',
    },
    paper: {
        width: '100%',
        height: 'calc(100% - 100px)',
        display: 'grid',
        padding: '0px',
        overflowY: 'hidden',
    },
    bar: {
        fontSize: '24px',
    },
    title: {
        flexGrow: 1,
    },
}));
export default function MediaUpload({ render, onSelect }) {
    const [open, setOpen] = useState(false);
    const openModal = useCallback(() => setOpen(true), [setOpen]);
    const closeModal = useCallback(() => setOpen(false), [setOpen]);
    const classes = useStyles();
    return (React.createElement(React.Fragment, null,
        React.createElement(Dialog, { maxWidth: 'xl', fullWidth: true, open: open, onClose: closeModal, classes: { root: classes.dialog, paper: classes.dialogPaper }, scroll: 'body' },
            React.createElement(DialogTitle, null,
                React.createElement(Toolbar, { className: classes.bar },
                    React.createElement(Typography, { variant: "h4", className: classes.title }, "Selecteur de media"),
                    React.createElement(IconButton, { onClick: () => closeModal(), color: "inherit" },
                        React.createElement(CloseIcon, null)))),
            React.createElement(DialogContent, { className: classes.paper, dividers: true },
                React.createElement(MediaBrowser, { onMediaSelect: (media) => {
                        onSelect({
                            id: media.id,
                            alt: media['alt'],
                            url: '/api/media/' + media.id,
                            size: media.size,
                        });
                        closeModal();
                    } }))),
        render({ open: openModal })));
}
//# sourceMappingURL=MediaUpload.js.map